export const extractIds = sqs =>
  sqs.flatMap(sq =>
    sq.questionType === "Custom"
      ? [sq.id, ...extractIds(sq.subQuestions)]
      : [sq.id],
  )
